<!--  -->
<template>
  <section class="">
    <RecoryIntro v-if="isRebuilding" :product="product"></RecoryIntro>
    <PhotoIntro v-else-if="isPhoto" :product="product"></PhotoIntro>
    <CommonIntro :product="product" v-else />
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState } from 'vuex'
import CommonIntro from './common-introduce'
import RecoryIntro from './recory-introduce'
import PhotoIntro from './photo-introduce'
import PROUDCT_TYPE from './config'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    CommonIntro,
    RecoryIntro,
    PhotoIntro
  },
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState([
      'product',
      'viewName',
      'comments',
      'commentCount',
      'selectedWorker',
      'selectedAddress',
      'selectedTime',
      'locationInfo',
      'selectedSku',
      'isMinProgram'
    ]),
    isPhoto() {
      return (
        this.product &&
        this.product.spuId &&
        +this.product.spuType === PROUDCT_TYPE.PHOTO_PRODUCT
      )
    },
    isRebuilding() {
      // 产后恢复
      return (
        this.product &&
        this.product.spuId &&
        +this.product.spuType === PROUDCT_TYPE.YU_ER &&
        this.product.level4CategoryId &&
        parseInt(+this.product.level4CategoryId / 100) === 101121
      )
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
</style>
